module.exports = __webpack_public_path__ + "static/media/gp_logo.7b38ab80.png";